module.exports = "<div class=\"collapse navbar-collapse navbar-ex1-collapse\">\n    <ul class=\"nav navbar-nav side-nav\">\n      <ng-container  *ngIf=\"userIsAdmin | async\">\n        <li *ngFor=\"let x of data.items\" routerLinkActive=\"active\">\n          <a routerLink=\"{{x.link}}\">\n            <span class=\"glyphicon\" [ngClass]=\"x.icon\"></span> {{x.name}}\n          </a>\n        </li>\n      </ng-container>\n    </ul>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/com/side-menu/side-menu.com.html
// module id = ./src/app/com/side-menu/side-menu.com.html
// module chunks = main